import { Button, Card, Typography, message } from "antd";
import CarouselBannerForm from "./form";
import List from "./list";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { fetchCarouselBanners } from "../../../../store/slices/bannerSlice";
import { updateStatus } from "../../../../api/banner";

const CarouselBanners = () => {
  const dispatch = useDispatch();
  const [showForm, handleForm] = useState(false);
  const [formData, setFormData] = useState(null);
  const { carouselBanners, isLoading } = useSelector(
    (state) => state?.banner
  );

  useEffect(() => {
    dispatch(fetchCarouselBanners());
  }, []);

  const onEditHandle = async (event) => {
    handleForm(true);
    setFormData(event);
  };

  const onStatusChange = async (card, status) => {
    try {
      const res = await updateStatus(card._id, { isActive: status });
      if (res) {
        message.success("Status updated successfully");
        dispatch(fetchCarouselBanners());
      }
    } catch (error) {
      message.error("An error occurred");
    }
  };

  const reloadBanners = () => {
    dispatch(fetchCarouselBanners());
    handleAddNewBanner();
  };

  const handleAddNewBanner = () => {
    handleForm(!showForm);
    setFormData(null);
  };

  return (
    <>
      <div className="grid gap-2 space-x-2 w-full pr-2">
        <div>
          <Card className="rounded-2xl bg-white xl:relative">
            <div className="border-solid border-inputFieldGrey rounded-sm p-2 lg:px-5">
              <div className="flex justify-between items-center">
                <Typography.Title level={3}>Carousel Banners</Typography.Title>
                <Button
                  type={showForm ? "link" : "primary"}
                  onClick={handleAddNewBanner}
                >
                  {showForm ? "Cancel" : "Add New Banner"}
                </Button>
              </div>
              {showForm && (
                <CarouselBannerForm
                  formData={formData}
                  reloadBanners={reloadBanners}
                  isEdit={!!formData}
                />
              )}
              {!showForm && (
                <>
                  <List
                    savedCards={carouselBanners}
                    onEdit={onEditHandle}
                    onStatusChange={onStatusChange}
                    isLoading={isLoading}
                    title={"Carousel Banners"}
                  />
                </>
              )}
            </div>
          </Card>
        </div>
      </div>
    </>
  );
};
export default CarouselBanners;
